import BaseComponent from "../base-component.js";
import { h } from "preact";

export default class OrderingPreviewComponent extends BaseComponent {
    responseCollector() {
        let choices = this.props.item.responseDeclaration.choices;
        if (!choices) return null;

        /**
         * @type {Object<number, import("../../shared-types.js").ItemChoice>}
         */
        let choicesById = choices.reduce((acc, choice) => {
            acc[Number(choice.id)] = choice;
            return acc;
        }, {});


        let definition = this.props.item.correctResponse.definition ? this.props.item.correctResponse.definition[0] : null;
        if(!definition) return null;
        let correctResponse = definition.matches;

        return (
            <div class="response-collector">
                <div className="ordering-match-container">
                    {correctResponse.map((id, index) => {
                        let choice = id !== null ? choicesById[Number(id)] : null;
                        return (
                            <div className="ordering-row">
                                <div className="ordering-target" data-index={index}>
                                    {choice ? <div
                                        key={choice.id}
                                        id={`ordering-choice-${choice.id}`}
                                        data-id={choice.id}
                                        className="ordering-choice"
                                    >
                                        <div
                                            class="ordering-choice-content"
                                            dangerouslySetInnerHTML={{ __html: choice.body }}
                                        ></div>
                                    </div> : null}

                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        return this.wrapper(this.body(), this.responseCollector());
    }
}